'use strict';

/*
Name: Search
*/

class Search {

  constructor () {
    var forms = document.querySelectorAll('.region__content form');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('input[name="submit-url"]')) {
        this.form = forms[i];
        this.submitUrl = forms[i].querySelector('input[name="submit-url"]').value;
        this.contentType = forms[i].querySelector('input[name="content-type"]').value;
        if (forms[i].querySelector('input[type="submit"]')) {
          this.submitButton = forms[i].querySelector('input[type="submit"]');
          this.currentPage = 0;
          this.submitButton.addEventListener('click', this.postSearch.bind(this, this.submitButton));
          this.selects = this.form.querySelectorAll('select,input[type="text"]');
          for (var s = 0; s < this.selects.length; s++) {
            this.selects[s].addEventListener('change', this.resetPager.bind(this, this.selects[s]));
          }
          this.resultsRegion = this.form.querySelector('.results-region');
          this.resultsRegion.addEventListener('click', this.resultsActions.bind(this, this.resultsRegion));
          this.resultsGrid = this.resultsRegion.querySelector('.results');
          this.prev = this.resultsRegion.querySelector('.prev');
          this.next = this.resultsRegion.querySelector('.next');
        }
      }
    }
  }

  resetPager(el, e) {
    this.currentPage=0;
  }

  resultsActions(el, e) {
    if (e.target.rel == 'next' || e.target.rel == 'prev') {
      if (e.target.rel == 'next') {
        this.currentPage++;
      }
      if (e.target.rel == 'prev') {
        this.currentPage--;
      }
      e.preventDefault();
      history.pushState(null,null,'?page=' + this.currentPage);
      this.postSearch(el, e);
    }
  }



  postSearch(el, e) {
    e.preventDefault();
    this.queryTime = Date.now();
    var xhr = new XMLHttpRequest();
		xhr.onload = e => {
			if (xhr.status == 200) {
        var response = JSON.parse(xhr.responseText);
        if (this.queryTime  == response.queryTime) {
    			if (response.results) {
    				var html = '';
    				for (var i = 0; i < response.results.length; i++) {
      				html += response.results[i];
    				}
    				this.resultsGrid.innerHTML = html;
    				if (document.querySelector('.results__count')) {
      				document.querySelector('.results__count').innerHTML = response.result_count;//results.length + ' results found';
    				}
      		} else {
    				this.resultsGrid.innerHTML = '<div class="results__empty">Sorry, nothing found.</div>';
  				}
  				if (response.prev == 'visible') {
    				this.prev.classList.remove('hidden');
  				} else {
    				this.prev.classList.add('hidden');
  				}
  				if (response.next == 'visible') {
    				this.next.classList.remove('hidden');
  				} else {
    				this.next.classList.add('hidden');
  				}
				}
    		this.resultsRegion.classList.remove('waiting');
			}
		}
		var ps = '?page=' + this.currentPage;
		this.resultsRegion.classList.add('waiting');
		var q = '?queryTime=' + this.queryTime + '&contentType=' + this.contentType + '&page=' + this.currentPage;
		for (var i = 0; i < this.selects.length; i++) {
  		q += '&' + this.selects[i].name + '=' + this.selects[i].value;
  		ps += '&' + this.selects[i].name + '=' + this.selects[i].value;
		}
    history.pushState(null,null, ps);
		xhr.open('GET', this.submitUrl + q, true);
		xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
		xhr.send();
  }
}


module.exports = Search;
